<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="responsive-card-title" i18n>Withdrawal Details</div>

    <ng-container *ngIf="!hasChanges">
      <div class="unchanged-withdrawal-instructions-grid">
        <app-vb-review-withdrawal-details-withdrawal-instruction
          *ngFor="let item of unchangedDisplayItems"
          class="instruction-item"
          [fundType]="item.instruction.fund"
          [balance]="item.instruction.fundBalance"
          [percentage]="item.instruction.percentage" />
      </div>
    </ng-container>

    <ng-container *ngIf="hasChanges">
      <div class="d-flex flex-column gap-3">
        <div class="d-flex flex-column gap-2">
          <span class="change-label" i18n>Current</span>
          <div class="changed-withdrawal-instructions-grid">
            <app-vb-review-withdrawal-details-withdrawal-instruction
              *ngFor="let item of currentDisplayItems"
              class="instruction-item"
              [class.current-highlight]="item.changed"
              [fundType]="item.instruction.fund"
              [balance]="item.instruction.fundBalance"
              [percentage]="item.instruction.percentage" />
          </div>
        </div>

        <div class="d-flex flex-column gap-2">
          <span class="change-label" i18n>New</span>
          <div class="changed-withdrawal-instructions-grid">
            <app-vb-review-withdrawal-details-withdrawal-instruction
              *ngFor="let item of newDisplayItems"
              class="instruction-item"
              [class.new-highlight]="item.changed"
              [fundType]="item.instruction.fund"
              [balance]="item.instruction.fundBalance"
              [percentage]="item.instruction.percentage" />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
